exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    background-color: #fff;\n}\n\n.index_app_3Qs6X {\n    /* Contentor do React: fundo opaco + stacking acima do #pre-loading (z-index negativo no index.ejs).\n       Sem isto, o splash azul “Loading...” ficava visível através do .app transparente. */\n    position: relative;\n    z-index: 1;\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    min-width: 1024px;\n    min-height: 640px; /* Min height to fit sprite/backdrop button */\n}\n\n/* @todo: move globally? Safe / side FX, for blocks particularly? */\n\n* { -webkit-box-sizing: border-box; box-sizing: border-box; }\n", ""]);

// exports
exports.locals = {
	"app": "index_app_3Qs6X"
};